module.exports = __webpack_public_path__ + "media/device_images/iphone-roster-index-81d38474.svg";